<template>
  <article
    class="entity-card"
    :class="{ 'entity-card-featured': reference.featured, 'entity-card-clickable': detailRoute }"
    :role="detailRoute ? 'link' : null"
    :tabindex="detailRoute ? 0 : null"
    @click="openDetails"
    @keydown.enter="openDetails"
  >
    <v-img
      v-if="cardImage"
      :src="cardImage.src | mediaSrc"
      :alt="cardImage.alt"
      :position="cardImage.position || 'center center'"
      aspect-ratio="1.6"
      class="entity-image"
    ></v-img>
    <div class="entity-content">
      <div class="entity-meta">
        <span>{{ typeLabel }}</span>
        <span v-if="reference.dayLabel">{{ reference.dayLabel }}</span>
      </div>
      <h3>{{ reference.titleOverride || entity.name }}</h3>
      <p v-if="reference.eventDescription" class="entity-lede">{{ reference.eventDescription }}</p>
      <p v-else-if="entity.shortDescription" class="entity-lede">{{ entity.shortDescription }}</p>
      <dl v-if="storyItems.length" class="story-details">
        <div v-for="item in storyItems" :key="item.label">
          <dt>{{ item.label }}</dt>
          <dd>{{ item.value }}</dd>
        </div>
      </dl>
      <div v-if="entity.websiteUrl || entity.mapUrl" class="entity-links">
        <a v-if="entity.websiteUrl" :href="entity.websiteUrl" target="_blank" rel="noopener noreferrer" @click.stop>
          Website <v-icon x-small>mdi-open-in-new</v-icon>
        </a>
        <a v-if="entity.mapUrl" :href="entity.mapUrl" target="_blank" rel="noopener noreferrer" @click.stop>
          Map <v-icon x-small>mdi-map-marker-outline</v-icon>
        </a>
      </div>
      <span v-if="detailRoute" class="entity-detail-link">
        {{ reference.detailLabel || 'Explore the Story' }}
        <v-icon x-small>mdi-arrow-right</v-icon>
      </span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'EntityCard',
  props: {
    entity: { type: Object, required: true },
    reference: { type: Object, required: true },
    detailRoute: { type: [Object, String], default: null },
  },
  computed: {
    cardImage() {
      return this.reference.cardImage || this.entity.heroImage;
    },
    typeLabel() {
      const labels = {
        restaurant: 'Food & Drink', hotel: 'Hotel', activity: 'Experience', place: 'Place', session: 'Session', venue: 'Venue',
      };
      return labels[this.entity.entityType] || this.entity.entityType;
    },
    storyItems() {
      return [
        ['Why we went', this.reference.whyWeWent],
        ['What happened', this.reference.whatHappened],
        ['What we remember', this.reference.whatWeRemember],
        ['Our take', this.reference.recommendation],
      ].filter(([, value]) => value).map(([label, value]) => ({ label, value }));
    },
  },
  methods: {
    openDetails() {
      if (this.detailRoute) this.$router.push(this.detailRoute);
    },
  },
};
</script>

<style scoped>
.entity-card { background: linear-gradient(145deg, #151515, #090909); border: 1px solid #2c2c2c; border-radius: 12px; overflow: hidden; }
.entity-card-clickable { cursor: pointer; transition: border-color 160ms ease, transform 160ms ease; }
.entity-card-clickable:hover, .entity-card-clickable:focus { border-color: #e23232; outline: none; transform: translateY(-2px); }
.entity-card-featured { border-color: rgba(240, 177, 60, 0.68); box-shadow: 0 0 0 1px rgba(240, 177, 60, 0.12); }
.entity-image { border-bottom: 1px solid #2c2c2c; }
.entity-content { padding: 24px; }
.entity-meta { color: #e23232; display: flex; font-size: 0.76rem; font-weight: 800; gap: 10px; justify-content: space-between; letter-spacing: 0.08em; text-transform: uppercase; }
h3 { color: #fff; font-family: "Oswald", sans-serif; font-size: 1.65rem; line-height: 1.08; margin: 10px 0 14px; }
.entity-lede { color: #c9c9c9; line-height: 1.65; margin: 0; }
.story-details { border-top: 1px solid #2a2a2a; display: grid; gap: 15px; margin: 20px 0 0; padding-top: 18px; }
.story-details dt { color: #f0b13c; font-size: 0.72rem; font-weight: 800; text-transform: uppercase; }
.story-details dd { color: #bdbdbd; line-height: 1.55; margin: 4px 0 0; }
.entity-links { display: flex; gap: 16px; margin-top: 20px; }
.entity-links a { color: #f0b13c; font-weight: 700; text-decoration: none; }
.entity-links .v-icon { color: inherit; }
.entity-detail-link { align-items: center; color: #f0b13c; display: inline-flex; font-weight: 800; gap: 5px; margin-top: 20px; text-transform: uppercase; }
.entity-detail-link .v-icon { color: inherit; }
</style>
